import { getAvatarSizeError } from '../../../utils/helpers/avatarUpload';
import { toast } from '../../../utils/helpers/toastUtils';

/** A picked photo: what `uploadFile` takes, and a local URI to preview it before it is saved. */
export type PickedAvatar = {
	file: File;
	previewUri: string;
};

/**
 * Web: opens the browser's file chooser for one image. Resolves to null when nothing usable was
 * picked - cancelled, or too large (the user is told why) - so the caller only handles a photo.
 */
export const pickAvatarFile = (): Promise<PickedAvatar | null> =>
	new Promise(resolve => {
		const input = document.createElement('input');
		input.type = 'file';
		input.accept = 'image/*';
		input.onchange = () => {
			const file = input.files?.[0];
			if (!file) {
				resolve(null);
				return;
			}
			const sizeError = getAvatarSizeError(file.size);
			if (sizeError) {
				toast.errorText('Image too large', sizeError);
				resolve(null);
				return;
			}
			resolve({ file, previewUri: URL.createObjectURL(file) });
		};
		// Closing the chooser without a file fires `cancel` (where supported) rather than `change`.
		input.addEventListener('cancel', () => resolve(null));
		input.click();
	});
